// extracted by mini-css-extract-plugin
export default {"musicasPage":"MusicasPage_musicasPage__kf0xW","musicasList":"MusicasPage_musicasList__k4Zex"};